module.exports = __webpack_public_path__ + "img/firSub1.5e293040.png";